import { create } from "zustand";

type GCSyncState = {
  /** Set of class IDs currently being synced by auto-sync */
  syncingClassIds: Set<string>;
  /**
   * Mark a class as being synced. Returns true if sync was started, false if already syncing.
   * This is atomic - prevents race conditions when multiple components try to sync the same class.
   */
  startSyncing: (classId: string) => boolean;
  /** Mark a class as done syncing */
  stopSyncing: (classId: string) => void;
  /** Check if a class is being synced */
  isSyncing: (classId: string) => boolean;
};

export const useGCSyncStore = create<GCSyncState>()((set, get) => ({
  syncingClassIds: new Set(),
  startSyncing: (classId) => {
    // Atomic check-and-set to prevent race conditions
    const state = get();
    if (state.syncingClassIds.has(classId)) {
      return false; // Already syncing
    }
    set({
      syncingClassIds: new Set(state.syncingClassIds).add(classId),
    });
    return true; // Sync started
  },
  stopSyncing: (classId) =>
    set((state) => {
      const newSet = new Set(state.syncingClassIds);
      newSet.delete(classId);
      return { syncingClassIds: newSet };
    }),
  isSyncing: (classId) => get().syncingClassIds.has(classId),
}));
